import { browser } from '$app/environment';
import { derived, writable } from 'svelte/store';
import { en } from './languages/en/en.i18n.js';
import { fr } from './languages/fr/fr.i18n.js';
import { it } from './languages/it/it.i18n.js';

// Lingue supportate
export const supportedLanguages = ['en', 'it', 'fr'];
export const defaultLanguage = 'en';

// Store per la lingua corrente
export const currentLanguage = writable(defaultLanguage);

// Traduzioni
const translations = {
	en: en,
	it: it,
	fr: fr,
};

// Store derivato per le traduzioni della lingua corrente
export const t = derived(currentLanguage, ($currentLanguage) => {
	return (key, params = {}) => {
		const keys = key.split('.');
		let value = translations[$currentLanguage];

		console.log(`Translating key: ${key} in language: ${$currentLanguage}`);
		
		for (const k of keys) {
			console.log(`Accessing key: ${k}`);
			if (value && typeof value === 'object') {
				value = value[k];
				console.log(`Current value: ${JSON.stringify(value)}`);
			} else {
				return key; // Ritorna la chiave se la traduzione non esiste
			}
		}

		console.log(`Translation found: ${value} for key: ${key}`);
		
		let result = value || key;
		
		// Se il risultato è una stringa e ci sono parametri, sostituisce i placeholder
		if (typeof result === 'string' && Object.keys(params).length > 0) {
			result = result.replace(/\{(\w+)\}/g, (match, paramName) => {
				return params[paramName] !== undefined ? params[paramName] : match;
			});
		}
		
		return result;
	};
});

// Funzione per cambiare lingua
export function setLanguage(lang) {
	if (supportedLanguages.includes(lang)) {
		currentLanguage.set(lang);
		if (browser) {
			localStorage.setItem('language', lang);
		}
	}
}

// Funzione per ottenere la lingua dal localStorage o dal browser
export function getLanguageFromStorage() {
	if (!browser) return defaultLanguage;
	
	const stored = localStorage.getItem('language');
	if (stored && supportedLanguages.includes(stored)) {
		return stored;
	}
	
	// Fallback alla lingua del browser
	const browserLang = navigator.language.split('-')[0];
	return supportedLanguages.includes(browserLang) ? browserLang : defaultLanguage;
}